export const getContacts = state => state.contacts.items;
export const getFilterInput = state => state.filter;
export const getIsLoading = state => state.contacts.isLoading;
export const getError = state => state.contacts.error;
